import { render, staticRenderFns } from "./TopBarSharing.vue?vue&type=template&id=22702524&scoped=true&"
import script from "./TopBarSharing.vue?vue&type=script&lang=js&"
export * from "./TopBarSharing.vue?vue&type=script&lang=js&"
import style0 from "./TopBarSharing.vue?vue&type=style&index=0&id=22702524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22702524",
  null
  
)

export default component.exports